import React, { } from 'react';
import PropTypes from 'prop-types';

import { useSearchState, useSearchDispatch } from '../../hooks/use_search_state';
import useSearch from '../../hooks/use_search';
import Results from '../results/results';
import SearchControls from './search_controls';
import SearchStyles from './styles/search_styles';
import ResultStyles from './styles/result_styles';
import OnSaleOnly from './on_sale_only';

export default function Deals(props) {
  const {
    settings,
  } = props;

  const {
    showMoreResults,
  } = settings;

  const {
    setPage,
    setOnSaleOnly,
  } = useSearchDispatch();

  const searchArgs = useSearchState();

  const {
    onSaleOnly,
    page,
  } = searchArgs;

  const {
    results, loading, hasSearched, hasMore,
  } = useSearch(searchArgs, true, false);

  return (
    <div>
      <SearchStyles settings={settings} />
      <ResultStyles settings={settings} />
      <div className="snapgadget_controls_row snapgadget_controls_row_reverse">
        <OnSaleOnly
          settings={settings}
          onSaleOnly={onSaleOnly}
          onChange={(checked) => setOnSaleOnly(checked)}
        />
      </div>
      <Results
        allResults={results}
        settings={settings}
      />
      {showMoreResults
        ? (
          <SearchControls
            results={results}
            loadingSearch={loading}
            settings={settings}
            hasSearched={hasSearched}
            getMoreResults={() => setPage(page + 1)}
            hasMore={hasMore}
          />
        ) : null}
    </div>
  );
}

Deals.propTypes = {
  settings: PropTypes.shape({
    showMoreResults: PropTypes.bool,
  }).isRequired,
};
